import type { TeamSpaceInfo } from '@/app/types';

export const PERSONAL_USER_SPACE_ID = '0';
export const PERSONAL_TEAM_SPACE_ID = 'self';

export const PERSONAL_TEAM_SPACE: TeamSpaceInfo = {
  team_id: PERSONAL_TEAM_SPACE_ID,
  team_name: 'Personal',
  team_user_id: PERSONAL_TEAM_SPACE_ID,
  space_id: PERSONAL_TEAM_SPACE_ID,
  space_name: 'Personal',
  member_user_id: PERSONAL_TEAM_SPACE_ID,
  role: 'self',
  state: 'self',
};

export const isPersonalSpaceId = (spaceId?: string | null): boolean => {
  return !spaceId || spaceId === PERSONAL_USER_SPACE_ID || spaceId === PERSONAL_TEAM_SPACE_ID;
};

export const buildTeamSpaces = (spaces: TeamSpaceInfo[] | undefined): TeamSpaceInfo[] => {
  if (!spaces?.length) {
    return [];
  }
  return [PERSONAL_TEAM_SPACE, ...spaces];
};

export const isSameTeamSpaceInfo = (prev: TeamSpaceInfo | null, next: TeamSpaceInfo | null): boolean => {
  if (prev === next) {
    return true;
  }
  if (!prev || !next) {
    return false;
  }
  return (
    prev.space_id === next.space_id &&
    prev.team_id === next.team_id &&
    prev.team_name === next.team_name &&
    prev.role === next.role &&
    prev.state === next.state
  );
};

export const isSameTeamSpaceList = (prev: TeamSpaceInfo[], next: TeamSpaceInfo[]): boolean => {
  if (prev.length !== next.length) {
    return false;
  }
  return prev.every((space, index) => isSameTeamSpaceInfo(space, next[index] ?? null));
};

export const findTeamSpaceById = (spaces: TeamSpaceInfo[], spaceId?: string | null): TeamSpaceInfo | null => {
  if (isPersonalSpaceId(spaceId)) {
    return PERSONAL_TEAM_SPACE;
  }
  return spaces.find((space) => space.space_id === spaceId) ?? null;
};
